import { all } from "redux-saga/effects";
import { emailLoginWatcher, forgotPasswordWatcher, googleLoginWatcher, resetPasswordWatcher, verifyTokenWatcher } from "./authSaga";
import { addTeamUserWatcher, addTeamWatcher, deleteTeamUserWatcher, deleteTeamWatcher, editTeamWatcher, teamListWatcher, tlDropdownWatcher, userDropdownWatcher, viewTeamWatcher } from "./teamSaga";
import { addUserWatcher, uploadCSVFileWatcher, uploadUsersWatcher, userDeleteWatcher, userEditWatcher, userListWatcher, userStatusWatcher, userViewWatcher } from "./userSaga";
import { addFolderWatcher, folderDeleteWatcher, folderEditWatcher, folderListWatcher, folderViewWatcher } from "./folderSaga";
import { addDocumentWatcher, assignTeamWatcher, assignUserWatcher, deletedocumentWatcher, documentListWatcher, documentSummaryWatcher, editdocumentWatcher, foldersDropDownWatcher, teamsDropDownWatcher, translateSummaryWatcher, uploadFileWatcher, usersDropDownWatcher, viewdocumentWatcher } from "./documentSaga";
import { addGlossaryWatcher, deleteGlossaryWatcher, deleteTranslationMemoryWatcher, enableDisableTranslationMemoryWatcher, exportTranslationMemoryWatcher, listGlossaryWatcher, listTranslationMemoryWatcher, uploadGlossaryFileWatcher } from "./resourceSaga";
import { completeReviewWatcher, documentsDropDownWatcher, draftedDetailsWatcher, getHtmlTextBlocksWatcher, getPdfTextBlocksWatcher, getPptxTextBlocksWatcher, getSignedUrlWatcher, getWordTextBlocksWatcher, glossaryDropDownWatcher, listPostEditingWatcher, postEditWordWatcher, publishDocWatcher, sendPostEditingWatcher, sendToModelWatcher, translateDocWatcher, translateFileWatcher, translateHtmlFIleWatcher, translateMorePagesWatcher, translationJobListWatcher, updateHtmlFileWatcher, updatePdfFileWatcher, updatePostEditJobWatcher, updatePptxFileWatcher, updateWordFileWatcher, viewDocWatcher, viewTranslationJobWatcher } from "./translationSaga";
import { companyRegisterWatcher } from "./companySaga";
import { profileViewWatcher } from "./proflieSaga";
import { logsListWatcher } from "./logsSaga";

export default function* rootSaga() {
        yield all([
                googleLoginWatcher(),
                emailLoginWatcher(),
                forgotPasswordWatcher(),
                resetPasswordWatcher(),
                addUserWatcher(),
                userListWatcher(),
                userEditWatcher(),
                userDeleteWatcher(),
                userViewWatcher(),
                addTeamWatcher(),
                teamListWatcher(),
                userStatusWatcher(),
                userDropdownWatcher(),
                tlDropdownWatcher(),
                viewTeamWatcher(),
                deleteTeamWatcher(),
                editTeamWatcher(),
                folderListWatcher(),
                addFolderWatcher(),
                folderEditWatcher(),
                folderDeleteWatcher(),
                folderViewWatcher(),
                addDocumentWatcher(),
                editdocumentWatcher(),
                documentListWatcher(),
                uploadFileWatcher(),
                deletedocumentWatcher(),
                viewdocumentWatcher(),
                foldersDropDownWatcher(),
                teamsDropDownWatcher(),
                assignTeamWatcher(),
                uploadCSVFileWatcher(),
                uploadUsersWatcher(),
                addGlossaryWatcher(),
                listGlossaryWatcher(),
                deleteGlossaryWatcher(),
                uploadGlossaryFileWatcher(),
                glossaryDropDownWatcher(),
                assignUserWatcher(),
                usersDropDownWatcher(),
                documentsDropDownWatcher(),
                getSignedUrlWatcher(),
                translateDocWatcher(),
                viewDocWatcher(),
                documentSummaryWatcher(),
                translationJobListWatcher(),
                companyRegisterWatcher(),
                publishDocWatcher(),
                viewTranslationJobWatcher(),
                translateSummaryWatcher(),
                sendPostEditingWatcher(),
                listPostEditingWatcher(),
                postEditWordWatcher(),
                completeReviewWatcher(),
                profileViewWatcher(),
                verifyTokenWatcher(),
                deleteTeamUserWatcher(),
                addTeamUserWatcher(),
                getWordTextBlocksWatcher(),
                getPptxTextBlocksWatcher(),
                updateWordFileWatcher(),
                updatePptxFileWatcher(),
                sendToModelWatcher(),
                draftedDetailsWatcher(),
                getPdfTextBlocksWatcher(),
                updatePdfFileWatcher(),
                listTranslationMemoryWatcher(),
                deleteTranslationMemoryWatcher(),
                enableDisableTranslationMemoryWatcher(),
                translateMorePagesWatcher(),
                translateHtmlFIleWatcher(),
                getHtmlTextBlocksWatcher(),
                updateHtmlFileWatcher(),
                updatePostEditJobWatcher(),
                translateFileWatcher(),
                exportTranslationMemoryWatcher(),

                logsListWatcher(),
        ]);
}
